var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v2H0zm0 5h16v2H0zm0 5h16v2H0z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMiIgZmlsbD0iIzAwNGE4NSI+CiAgICA8cGF0aCBkPSJNMCAwaDE2djJIMHptMCA1aDE2djJIMHptMCA1aDE2djJIMHoiIGZpbGw9IiMwMDRhODUiIC8+Cjwvc3ZnPgo=";
export { SvgMenu as ReactComponent };